import React, { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom';
import styled, { css } from 'styled-components'

import PlayerPanelShared from '../components/PlayerPanelShared'
// import PageTurningSimpleBoard from './PageTurningSimpleBoard'
import FlipMove from 'react-flip-move';
import ScrollingSimpleBoard from './ScrollingSimpleBoard';

import { useStore } from '../zustandStore';

const PlayerPanelVertical = () => {
  useEffect(() => {
    console.log('Browser source size: 440 x 650')
  }, [])

  const { slug } = useParams()
  const [queryParams, _] = useSearchParams()

  const {
    player,
    event,
    layoutSettings,
  } = useStore(
    state => ({
      event: state.event,
      layoutSettings: state.layoutSettings,
      player: state.players.find(p => p.slug === slug),
    })
  )

  const pageSize = layoutSettings.obsPlayerVPanelPageSize
  // const pageSize = totalChapterCount > 7 ? 4 : 5
  // debugger
  return (
    <StylingWrapper pageSize={pageSize} help={queryParams.get('help')}>
      <FlipMove className='flip-move' enterAnimation='fade' leaveAnimation='fade' duration={650}>
        <PanelStylingWrapper layoutSettings={layoutSettings} key={slug}>
          <PlayerPanelShared player={player} event={event} />
        </PanelStylingWrapper>
      </FlipMove>

      <ScrollingSimpleBoard
        pageSize={pageSize}
        highlightedPlayerSlug={slug}
        pageTimeQueryParam='vpanel_page_time'
      />
    </StylingWrapper>
  )
}

export default PlayerPanelVertical

// const Divider = styled.div`
//   border-bottom: 2px solid #aaa;
//   width: 100%;
//   margin-left: auto;
//   margin-right: auto;
//   flex-grow: 1;
// `

const StylingWrapper = styled.div`
  /* overflow-anchor: none; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  overflow-y: hidden;

  .flip-move {
    /* overflow-anchor: none; */
  }

  .simple-board-wrapper, .simple-board-table {
    ${'' /* controls width of scrolling leaderboard */}
    width: 100vw;
    margin-left: auto;
    margin-right: auto;
  }

  .simple-board-wrapper {
    position: fixed;
    bottom: 0;
    border-top: 2px solid #aaa;
  }

  .player-total {
    margin-right: 0.1em;
  }
  .simple-board-table {
    ${'' /* --row-font-size and --row-margin-v control the overall size & spacing everything in the scrolling leaderboard.
    the 1.29 is the empirical result of the scale between font size and height */}
    padding-top: 0px;
    --row-font-size: 30px;
    --row-margin-v: 2.5px;

    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;

    --row-height: calc(calc(var(--row-font-size) * 1.2) + calc(var(--row-margin-v) * 2));

    ${props => css`
      height: calc(var(--row-height) * ${props.pageSize});
    `}
    overflow-y: scroll;

    ${'' /* font-size controls overall scale of scrolling leaderboard, and margins control spacing between rows */}
    .row {
      font-size: var(--row-font-size);
      width: 97%;
      padding-right: 10px;
      padding-left: 5px;
      > * {
        /* margin-top: var(--row-margin-v); */
        margin-bottom: var(--row-margin-v);
      }
    }
    ${'' /* query param that highlights two very useful rows when it comes to formatting, also turns off scrolling */}
    ${props => props.help && css`
      .page:first-child {
        .row {
          &:first-child, &:nth-child(${(props) => props.pageSize}) {
            background-color: var(--highlighted-player-obs-color);
            .column-right {
              color: var(--total-color);
            }
          }
        }
      }
    `}
  }
`

// exported because the control panel reuses it
export const PanelStylingWrapper = styled.div`
  ${'' /* controls width of player section */}
  width: 100%;
  /* --font-size: 33.4px; */
  --font-size: ${props => props.layoutSettings.obsPlayerVPanelBodyFontSizePx || '37.5'}px;

  position: fixed;
  /* position: fixed prevents the panel from ever being scrolled on the off chance this browser source is not tall enough for its contents and the autoscrolling board below it makes it move */
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 10px;
  margin-bottom: 0px;

  .panel-wrapper {
    /* height: 73.5vh; */
    height: ${props => props.layoutSettings.obsPlayerVPanelChapterWrapperMinHeightVh || '67.5'}vh;
  }

  .chapter-times-body {
    font-size: 1.05em;
    line-height: 1.1em;
  }


  .player-title {
    ${'' /* padding-top: 0.29em;
    padding-bottom: 0.116em;
    height: 1.45em; */}
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    font-size: 45px;

  }

  ${'' /* .name-rank-wrapper {
    padding-left: 0.29em; */}
    .rank {
      font-size: 0.66em;
      ${'' /* margin-right: 0.15em;
      padding-bottom: 4px;
      width: 0.87em;
      line-height: 1.4em; */}
    }

    .name {
      line-height: 1em;
      padding-bottom: 0.2em;
    }
  ${'' /* } */}

  .flag {
    --flag-width: 62px;
    ${'' /* margin-top: 1em; */}
  }
`
